import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import ActionTypes from '../constants'

import {
  TwoFactorUserPayload,
  GetSecretCodeResponse,
  UserState,
} from '../models'

const apiService: RestApiService = Container.get(RestApiService)

export const getSecretCodesThunk = createAsyncThunk(
  ActionTypes.GET_SECRET_CODES,
  async (payload: TwoFactorUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'twoFactorAuthentication/enable',
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: GetSecretCodeResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getSecretCodeExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(getSecretCodesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getSecretCodesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.secretCode = payload.code
  })
}

export default getSecretCodeExtraReducer
